import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  height: 108px;
  max-width: 160px;
  border-radius: 3px;
  width: 100%;
  min-width: 200px;
  display: flex;
  margin-right: 8px;
  padding: 0 14px;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
  @media(max-width: 540px) {
    max-width: inherit;
    min-width: inherit;
  }
  a {
    text-decoration: none;
    width: 100%;
  }
  div {
    height: 100%;
    width: 100%;
    align-items: center;
    position: relative;
    z-index: 4;
    display: flex;
    justify-content: space-between;
    span {
      color: #fff;
      font: bold italic 22px/20px 'Times new roman';
    }
    i {
      border-radius: 3px;
      border: 2px solid #fff;
      min-width: 20px;
      height: 20px;
      margin-left: 10px;
      transition: background-color 0.3s;
      &.active {
        background: url(/images/check.svg) no-repeat center #fff;
      }
    }
  }
  .overlay {
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: all 0.3s;
    @media(max-width: 540px) {
      left: 5px;
      right: 5px;
      border-radius: 3px;
    }
  }
  &:hover {
    .overlay {
      background: rgba(0, 0, 0, 0.6);
    }
    div i {
      background-color: #fff;
    }
  }
  .img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-position: center;
    background-size: cover;
    @media(max-width: 540px) {
      left: 5px;
      right: 5px;
      border-radius: 3px;
    }
  }
`

class OptionBox extends Component {
  state = {
    term: '',
    type: '',
  }

  render = () => {
    const {nome, uid, filter, category, type, imagem} = this.props;
    return (
      <Container>
        <Link to={ `/produtos/${type}/${category}/${uid}`}>
          <span className="img" style={ { backgroundImage: `url(${imagem && imagem.url})`}}></span>
          <div>
            <span>
              { nome && nome[0].text }
            </span>
            <i className={ (filter.term === uid && category === filter.type) ? 'active' : '' }></i>
          </div>
        </Link>
      </Container>
    )
  }
}

OptionBox.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default OptionBox;
